import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
    mutation removeVimeoConnection ($id: ID!) {
      removeVimeoConnection (id: $id) {
        ...userProfileDetail
      }
    }
    ${fragments.userProfileDetail}
  `
